import { Stream } from '@tempest/core';
export function debug(infoOrSpy, stream) {
    return new Stream(new Debug(infoOrSpy, stream.source));
}
export class Debug {
    constructor(infoOrSpy, source) {
        this.infoOrSpy = infoOrSpy;
        this.source = source;
    }
    run(sink, scheduler) {
        if (typeof this.infoOrSpy === 'object') {
            if (typeof this.infoOrSpy.dispose === 'function') {
                const disposeSpy = this.infoOrSpy.dispose;
                const disposable = this.source.run(new DebugSink(this.infoOrSpy, sink), scheduler);
                return {
                    dispose() {
                        disposeSpy();
                        return disposable.dispose();
                    }
                };
            }
        }
        else {
            return this.source.run(new DebugSink(this.infoOrSpy, sink), scheduler);
        }
    }
}
class DebugSink {
    constructor(infoOrSpy, sink) {
        this.infoOrSpy = infoOrSpy;
        this.sink = sink;
    }
    event(time, value) {
        if (typeof this.infoOrSpy === 'string') {
            console.log(this.infoOrSpy + ':', value);
        }
        else if (typeof this.infoOrSpy === 'object') {
            if (typeof this.infoOrSpy.next === 'function') {
                this.infoOrSpy.next(value);
            }
        }
        this.sink.event(time, value);
    }
    error(time, err) {
        if (typeof this.infoOrSpy === 'object') {
            if (typeof this.infoOrSpy.error === 'function') {
                this.infoOrSpy.error(err);
            }
        }
        this.sink.error(time, err);
    }
    end(time, value) {
        if (typeof this.infoOrSpy === 'string') {
            console.log(this.infoOrSpy + ': ending');
        }
        else if (typeof this.infoOrSpy === 'object') {
            if (typeof this.infoOrSpy.complete === 'function') {
                this.infoOrSpy.complete(value);
            }
        }
        this.sink.end(time, value);
    }
}
//# sourceMappingURL=index.js.map